class InicioSesion extends HTMLElement {
  constructor() {
    super();
    this.configuracion = {
      clienteId:
        "510723753726-dae5f4mdo4o0cp0uuss6h1hcmq346225.apps.googleusercontent.com",
      permisos: "openid email profile",
      urlScript: "https://accounts.google.com/gsi/client",
    };
    // Si el estado es (true) con OTP(WhatsApp)
    // Si es (false) sin OTP(Email)
    this.estadoOTP = window.estadoOTP;
    this.codigoEnviadoCliente = null;
    this.coordenadas = { lat: -17.783315017953004, lng: -63.18214577296119 };
    this.confirmationResult = null;
    this.empleadosCallCenter = window.empleadosCallCenter || [];
  }

  connectedCallback() {
    // =============================================================================
    // CAPTURA DE ELEMENTOS DEL DOM
    // =============================================================================

    // --- ELEMENTOS DE INPUT Y VALIDACIÓN ---
    this.inputCorreoElectronico = this.querySelector(
      "#phpis-input-correo-electronico"
    );
    this.input = this.querySelector("#phpis-input");
    this.mensajeVerificarNumero = this.querySelector(
      "#phpis-mensaje-verificar-numero"
    );
    this.mensajeErroCodigo = this.querySelector(".phpis-mensaje-error");

    // --- BOTONES PRINCIPALES ---
    this.btnIniciarSesion = this.querySelector("#phpis-btn-iniciar-sesion");
    this.btnReenviarCodigo = this.querySelector("#phpis-btn-reenviar");
    // this.btnGoogle = this.querySelector('#phpis-btn-google');
    // this.btnFacebook = this.querySelector('#phpis-btn-facebook');

    // --- CONTENEDORES PRINCIPALES ---
    this.containerGeneral = this.querySelector("#phpis-container-modal");
    this.containerMensaje = this.querySelector("#phpis-mensaje-proceso");
    this.containerExito = this.querySelector("#phpis-mp-exito");
    this.containerVerificarNumero = this.querySelector(
      "#phpis-mp-verificar-numero"
    );
    // this.containerSnipper = this.querySelector('#phpis-snipper-modal');

    // --- INPUTS DE VERIFICACIÓN (6 DÍGITOS) ---
    this.input1Verificacion = this.querySelector("#single-digit1");
    this.input2Verificacion = this.querySelector("#single-digit2");
    this.input3Verificacion = this.querySelector("#single-digit3");
    this.input4Verificacion = this.querySelector("#single-digit4");
    this.input5Verificacion = this.querySelector("#single-digit5");
    this.input6Verificacion = this.querySelector("#single-digit6");

    // =============================================================================
    // ASIGNACIÓN DE EVENT LISTENERS
    // =============================================================================

    // --- EVENTOS PARA BOTONES ---
    this.btnIniciarSesion.addEventListener(
      "click",
      this.iniciarSesion.bind(this)
    );
    this.btnReenviarCodigo.addEventListener(
      "click",
      this.procesoReenviarCodigo.bind(this)
    );

    // --- EVENTOS PARA INPUTS DE VERIFICACIÓN ---
    this.input1Verificacion.addEventListener(
      "input",
      this.verificarNumero.bind(this)
    );
    this.input2Verificacion.addEventListener(
      "input",
      this.verificarNumero.bind(this)
    );
    this.input3Verificacion.addEventListener(
      "input",
      this.verificarNumero.bind(this)
    );
    this.input4Verificacion.addEventListener(
      "input",
      this.verificarNumero.bind(this)
    );
    this.input5Verificacion.addEventListener(
      "input",
      this.verificarNumero.bind(this)
    );
    this.input6Verificacion.addEventListener(
      "input",
      this.verificarNumero.bind(this)
    );

    // --- EVENTO PARA CERRAR MODAL AL HACER CLICK FUERA ---
    document.addEventListener("click", (event) => {
      // Verificar si ambos contenedores están visibles
      if (
        this.containerGeneral.style.display === "flex" &&
        this.containerVerificarNumero.style.display === "flex"
      ) {
        // Si el clic fue dentro del containerGeneral pero NO dentro del containerVerificarNumero
        if (
          this.containerGeneral.contains(event.target) &&
          !this.containerVerificarNumero.contains(event.target)
        ) {
          this.containerGeneral.style.display = "none";
        }
      }
    });

    // --- SWITCH DEL OTP ---
    this.contenedorBaseInputCorreoElectronico =
      this.querySelector(".ph-mcci-input");
    this.btnCambioMetodoIngreso = this.querySelector(
      "#phpis-btn-cambio-iniciar-sesion"
    );
    this.etiquetaCambioMetodoIngreso = this.querySelector(
      "#phpis-etiqueta-iniciar-sesion"
    );
    this.btnCambioMetodoIngreso.addEventListener("click", () =>
      this.cambiarMetodoIngreso()
    );

    if (window.estadoOTP) {
      this.estadoOTP = false;
      this.cambiarMetodoIngreso();
      this.etiquetaCambioMetodoIngreso.innerHTML = "INICIAR SESION CON EMAIL";
    } else {
      this.estadoOTP = true;
      this.cambiarMetodoIngreso();
      this.etiquetaCambioMetodoIngreso.innerHTML =
        "INICIAR SESION CON WHATSAPP";
    }

    this.btnIniciarSesionGoogle = this.querySelector(
      "#phpis-btn-iniciar-sesion-google"
    );
    this.btnIniciarSesionFacebook = this.querySelector(
      "#phpis-btn-iniciar-sesion-facebook"
    );

    this.btnIniciarSesionGoogle.addEventListener("click", () =>
      this.inicio_sesion_google_OAuth2()
    );
    this.btnIniciarSesionFacebook.addEventListener("click", () =>
      this.simulacionClickBtnFacebook()
    );

    // =============================================================================
    // INICIALIZACIÓN DE COMPONENTE
    // =============================================================================

    // --- CONFIGURACIÓN INICIAL ---
    this.reiniciarProceso();
    this.ocultarElementosBase();
  }

  verificarInput() {
    // Validar teléfono (exactamente 8 dígitos)
    const telefonoValido =
      this.input.value.length == 8 && /^\d{8}$/.test(this.input.value);

    let esValido = telefonoValido;

    // Si OTP está desactivado, también validar email
    if (!this.estadoOTP) {
      const emailValido =
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
          this.inputCorreoElectronico.value.trim()
        );
      esValido = telefonoValido && emailValido;
    }

    return !esValido;
  }

  async iniciarSesion() {
    if (this.estadoOTP == true) {
      // OTP ACTIVADO

      if (this.verificarInput()) {
        MensajeTemporal.mostrarMensaje(
          "Ingrese un número de teléfono válido de 8 dígitos.",
          "alerta",
          3500
        );
        return;
      }

      // Validacion del input de telefono
      if (this.input.value.length != 8) {
        MensajeTemporal.mostrarMensaje(
          "Ingrese un número de teléfono válido de 8 dígitos.",
          "alerta",
          3500
        );
        return;
      }

      this.mensajeVerificarNumero.innerHTML = `Enviamos un código de verificación 
        de 4 dígitos a tu  número de WhatsApp *****${this.input.value.slice(
          -3
        )}. 
        Copia ese código y pégalo a continuación:`;

      const verificarSiFueEnviado = await GestorClienteShopify.enviarCodigoOTP(
        `+591${this.input.value}`
      );

      if (verificarSiFueEnviado) {
        // Si el codigo fue enviado
        MensajeCargaDatos.ocultar();
        this.containerGeneral.style.display = "flex";
        this.containerMensaje.style.display = "flex";
        this.containerVerificarNumero.style.display = "flex";
        return;
      } else {
        MensajeTemporal.mostrarMensaje(
          "Sucedió un error intente reenviar un nuevo código por favor.",
          "error",
          3500
        );
        return;
      }
    } else {
      // OTP DESACTIVADO

      if (this.verificarInput()) {
        MensajeTemporal.mostrarMensaje(
          "Ingrese un correo electrónico y un número de teléfono válidos.",
          "alerta",
          3500
        );
        return;
      }

      MensajeCargaDatos.mostrar("Espera un momento, verificando datos ...");

      try {
        const resultado = await GestorClienteShopify.procesoInicioSesionSinOTP(
          this.inputCorreoElectronico.value.trim(),
          this.input.value.trim()
        );

        if (resultado && resultado.success == false) {
          return;
        }
      } catch (error) {
        MensajeCargaDatos.ocultar();
        console.error("Error en iniciar sesión:", error);
        MensajeTemporal.mostrarMensaje(error.message, "error", 3500);
        return;
      }
    }

    MensajeCargaDatos.ocultar();
    // Mostrar mensaje de éxito y redirigir al index
    this.containerVerificarNumero.style.display = "none";
    this.containerGeneral.style.display = "flex";
    this.containerMensaje.style.display = "flex";
    this.containerExito.style.display = "flex";

    setTimeout(() => {
      this.containerGeneral.style.display = "none";
      this.containerMensaje.style.display = "none";
      this.containerExito.style.display = "none";

      const params = new URLSearchParams(window.location.search);
      const returnUrl = params.get("return_url");
      if (returnUrl) {
        window.location.replace(returnUrl);
      } else if (document.referrer && document.referrer !== window.location.href) {
        window.location.replace(document.referrer);
      } else {
        window.location.replace("/");
      }
    }, 2000);
  }

  async verificarNumero(event) {
    const inputs = [
      this.input1Verificacion,
      this.input2Verificacion,
      this.input3Verificacion,
      this.input4Verificacion,
      this.input5Verificacion,
      this.input6Verificacion,
    ];

    // Obtener el elemento de entrada actual que desencadenó el evento
    const inputActual = event.target;

    // Encontrar el índice del input actual en nuestro array
    const indiceActual = inputs.indexOf(inputActual);

    // Si el input actual tiene un valor y hay un siguiente input, enfócalo
    if (inputActual.value.length === 1 && indiceActual < inputs.length - 1) {
      inputs[indiceActual + 1].focus();
    }

    // Verificar si todos los inputs están llenos
    const todosLlenos = inputs.every((input) => input.value.length === 1);

    if (todosLlenos) {
      MensajeCargaDatos.mostrar("Verificando código ...");
      const optenerNumero = inputs.map((input) => input.value).join("");
      const validacionCodigo = await GestorClienteShopify.validarCodigoOTP(
        optenerNumero,
        `+591${this.input.value}`
      );

      if (validacionCodigo) {
        this.containerGeneral.style.display = "none";
        this.containerMensaje.style.display = "none";

        try {
          let resultado = await GestorClienteShopify.procesoInicioSesionConOTP(
            this.input.value
          );

          if (resultado.success == false) {
            return;
          }

          MensajeCargaDatos.ocultar();
          this.containerVerificarNumero.style.display = "none";
          this.containerGeneral.style.display = "flex";
          this.containerMensaje.style.display = "flex";
          this.containerExito.style.display = "flex";

          setTimeout(() => {
            this.containerGeneral.style.display = "none";
            this.containerMensaje.style.display = "none";
            this.containerExito.style.display = "none";

            const params = new URLSearchParams(window.location.search);
            const returnUrl = params.get("return_url");
            if (returnUrl) {
              window.location.replace(returnUrl);
            } else if (document.referrer && document.referrer !== window.location.href) {
              window.location.replace(document.referrer);
            } else {
              window.location.replace("/");
            }
          }, 2000);
          return;
        } catch (error) {
          MensajeCargaDatos.ocultar();
          console.error("Error en iniciar sesión con OTP:", error);
          MensajeTemporal.mostrarMensaje(error.message, "error", 3500);
          return;
        }
      } else {
        MensajeCargaDatos.ocultar();
        this.mensajeErroCodigo.style.display = "flex";
        setTimeout(() => {
          this.mensajeErroCodigo.style.display = "none";
          inputs.forEach((input) => {
            input.value = "";
          });
          inputs[0].focus();
        }, 1500);
      }
    }
  }

  ocultarElementosBase() {
    this.containerGeneral.style.display = "none";
    // this.containerSnipper.style.display = 'none';
    this.containerMensaje.style.display = "none";
    this.containerExito.style.display = "none";
    this.containerVerificarNumero.style.display = "none";
  }

  reiniciarProceso() {
    // Ocultar todos los contenedores activos
    this.ocultarElementosBase();

    // Limpiar los campos de entrada
    this.input.value = "";
    this.input1Verificacion.value = "";
    this.input2Verificacion.value = "";
    this.input3Verificacion.value = "";
    this.input4Verificacion.value = "";
    this.input5Verificacion.value = "";
    this.input6Verificacion.value = "";

    // Mostrar solo la interfaz inicial (ajustar según tu diseño)
    // Si tienes un contenedor principal que debe estar visible, actívalo aquí
    // Por ejemplo: this.containerPrincipal.style.display = 'block';
  }

  async procesoReenviarCodigo() {
    await GestorClienteShopify.enviarCodigoOTP(`+591${this.input.value}`);
  }

  loginFacebookCallback(response) {
    console.log("👥 Facebook:", response);
    if (response.status === "connected") {
      FB.api("/me?fields=id,name,email", (userData) => {
        console.log("👥 Facebook Data:", userData);
      });
    }
  }

  async procesoInicioSesionGoogleOAuth2(userData) {
    try {
      var datosCliente = await GestorClienteShopify.validarCorreoElectronico(
        userData.email
      );

      if (datosCliente == null) {
        // Crear usuario
        datosCliente = await GestorClienteShopify.crearNuevoClienteShopify({
          nombre: userData.given_name,
          apellido: userData.family_name,
          email: userData.email,
          celular: "",
          ci: "",
          razon_social: "",
          nit: "",
          fecha_nacimiento: "",
          permisosHutCoins: false,
          direcciones: localStorage.getItem("ph-pre-seleccion-envio-domicilio")
            ? [
                JSON.parse(
                  localStorage.getItem("ph-pre-seleccion-envio-domicilio")
                ),
              ]
            : [
                {
                  lat: -17.51041339757574,
                  lng: -63.164604605594825,
                  indicaciones: "Plaza Principal de Warnes, Santa Cruz.",
                  alias: "Ubicación de entrega",
                },
              ],
        });
      }

      localStorage.setItem("ph-datos-usuario", JSON.stringify(datosCliente));
      localStorage.removeItem("ph-tipo-usuario");
      MensajeCargaDatos.ocultar();

      // Volver a la página anterior o ir al inicio
      if (window.location.href.includes("pages/crear-cuenta")) {
        window.location.replace("/");
      } else {
        // Lógica original para otras páginas
        if (document.referrer && document.referrer !== window.location.href) {
          window.location.replace(document.referrer);
        } else {
          window.location.replace("/");
        }
      }
    } catch (error) {
      console.error("Error al obtener datos del cliente:", error);
      MensajeCargaDatos.ocultar();
      MensajeTemporal.mostrarMensaje(error.message, "error", 3000);
      return;
    }
  }

  simulacionClickBtnFacebook() {
    console.log("Testing simulacionClickBtnFacebook");
    MensajeTemporal.mostrarMensaje(
      "No pudimos conectar con Facebook. Puedes intentar iniciar sesión con otro método.",
      "error",
      3000
    );
  }

  inicio_sesion_google_OAuth2() {
    google.accounts.oauth2
      .initTokenClient({
        client_id: this.configuracion.clienteId,
        scope: this.configuracion.permisos,
        callback: (respuesta) => {
          if (respuesta.access_token) {
            console.log("Token de acceso recibido");
            this.obtenerDatosUsuario(respuesta.access_token);
          }
        },
        error_callback: (error) => {
          console.error("Error en OAuth:", error);
          this.mostrarError(
            "No pudimos conectar con Google. Intenta con otro método."
          );
        },
      })
      .requestAccessToken();
  }

  async obtenerDatosUsuario(tokenAcceso) {
    try {
      const respuesta = await fetch(
        "https://www.googleapis.com/oauth2/v2/userinfo",
        {
          headers: { Authorization: `Bearer ${tokenAcceso}` },
        }
      );

      if (respuesta.ok) {
        const datosUsuario = await respuesta.json();
        console.log("Datos del usuario obtenidos:", datosUsuario);
        await this.procesoInicioSesionGoogleOAuth2(datosUsuario);
      } else {
        throw new Error("Error al obtener datos del usuario");
      }
    } catch (error) {
      console.error("Error obteniendo datos:", error);
      this.mostrarError("Error al obtener información del usuario");
    }
  }

  mostrarError(mensaje) {
    if (window.MensajeTemporal) {
      MensajeTemporal.mostrarMensaje(mensaje, "error", 3000);
    } else {
      alert(mensaje);
    }
  }

  cambiarMetodoIngreso() {
    console.log("Testing cambiarMetodoIngreso, estado actual:", this.estadoOTP);

    // Invertir el estado
    this.estadoOTP = !this.estadoOTP;

    // Actualizar la etiqueta del botón según el nuevo estado
    this.etiquetaCambioMetodoIngreso.innerHTML = this.estadoOTP
      ? "INICIAR SESION CON EMAIL"
      : "INICIAR SESION CON WHATSAPP";

    // Actualizar la visibilidad del input de correo
    this.contenedorBaseInputCorreoElectronico.style.display = this.estadoOTP
      ? "none"
      : "flex";

    // Limpiar los inputs cuando se cambia el método
    this.input.value = "";
    if (!this.estadoOTP) {
      this.inputCorreoElectronico.value = "";
    }
  }
}

customElements.define("inicio-sesion", InicioSesion);

// inicializarGoogle() {
//   if (this.googleListo) return;

//   const script = document.createElement("script");
//   script.src = "https://accounts.google.com/gsi/client";
//   script.async = true;
//   script.defer = true;
//   script.onload = () => setTimeout(() => this.configurarGoogleAPI(), 500);
//   script.onerror = () => console.error("Error cargando Google script");
//   document.head.appendChild(script);
// }

// configurarGoogleAPI() {
//   if (!window.google?.accounts) {
//     console.error('Google API no disponible');
//     return;
//   }

//   google.accounts.id.initialize({
//     client_id: this.configuracion.clienteId,
//     // callback: this.manejarRespuesta.bind(this),
//     auto_select: false,
//     cancel_on_tap_outside: true,
//     context: "signin"
//   });

//   this.googleListo = true;
//   console.log("Google API lista");
// }

// manejarLoginGoogle() {
//   console.log("Iniciando autenticación Google");

//   if (!this.googleListo) {
//     console.error("Google API no lista");
//     return;
//   }

//   google.accounts.id.prompt((notificacion) => {
//     if (notificacion.isNotDisplayed()) {
//       const razon = notificacion.getNotDisplayedReason();
//       console.log("Prompt no mostrado:", razon);

//       if (razon === "opt_out_or_no_session" || razon === "unknown") {
//         this.inicio_sesion_google_OAuth2();
//       } else if (razon === "browser_not_supported") {
//         this.mostrarError("Navegador no compatible para iniciar sesión con Google");
//         console.log('Testing razon',razon);
//       }
//     }
//   });
// }

// manejarRespuesta(respuesta) {
//   console.log("Respuesta recibida:", respuesta);

//   if (respuesta.credential) {
//     const datosUsuario = this.decodificarJWT(respuesta.credential);
//     this.loginExitoso(datosUsuario);
//   } else if (respuesta.code) {
//     console.log("Código recibido:", respuesta.code);
//     this.intercambiarCodigoPorToken(respuesta.code);
//   }
// }

// async intercambiarCodigoPorToken(codigo) {
//   try {
//     const datos = new URLSearchParams({
//       code: codigo,
//       client_id: this.configuracion.clienteId,
//       redirect_uri: 'postmessage',
//       grant_type: 'authorization_code'
//     });

//     const respuestaToken = await fetch('https://cors-anywhere.herokuapp.com/https://oauth2.googleapis.com/token', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
//       body: datos
//     });

//     const tokens = await respuestaToken.json();
//     console.log("Tokens recibidos:", tokens);

//     if (tokens.access_token) {
//       this.obtenerDatosUsuario(tokens.access_token);
//     }
//   } catch (error) {
//     console.error('Error intercambiando código:', error);
//     this.mostrarError('Error procesando autenticación');
//   }
// }

// decodificarJWT(token) {
//   const base64Url = token.split(".")[1];
//   const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
//   const payload = decodeURIComponent(
//     atob(base64)
//       .split("")
//       .map(c => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
//       .join("")
//   );
//   return JSON.parse(payload);
// }

// loginExitoso(datosUsuario) {
//   console.log("Login exitoso:", datosUsuario);
// }
